import { Routes as CoreRoutes } from 'core/pages'
import SimpleItemListReading from './SimpleItemList/SimpleItemListReading'
import SimpleParcelListStart from './SimpleParcelList/SimpleParcelListStart'

///////////////////////////////////////////////////////////////////////////////
// Custom & core overrides, change only this!
///////////////////////////////////////////////////////////////////////////////

const CustomRoutes = {
  '/simple-item-list/:opCode/reading': { component: SimpleItemListReading },
  '/simple-parcel-list/:opCode': { component: SimpleParcelListStart },
}

///////////////////////////////////////////////////////////////////////////////

export const Routes = { ...CoreRoutes, ...CustomRoutes }
// eslint-disable-next-line
export type Routes = keyof typeof Routes
